DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	const submitButton = '[data-exam-form-submit]';

	/**
	 * Initialize Button actions
	 */
	function init() {
		setup($(document));
	}

	/**
	 * Apply setup to our newly loaded area (document, or scope)
	 *
	 * @param scope | DOMObject - the area of the page we are applying this functionality to
	 */
	function setup(scope) {
		attachEvents(scope);
	}

	/**
	 * Attach events
	 * @param scope | DOMObject
	 */
	function attachEvents(scope) {
		scope.find(submitButton).on('click', function(e) {
			e.stopPropagation();
			e.preventDefault();
			sendRequest(scope);
		});

		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	function sendRequest(scope) {
		if (scope === undefined) {
			return false;
		}

		const fields = scope.find('[data-form-field]'),
			submissionID = scope.find('[name="SubmissionID"]')[0],
			form = scope.find('[data-custom-form]')[0],
			postSubmission = scope.find('[data-exam-form-post-content]')[0],
			content = scope.find('[data-exam-form-content]')[0],
			serverError = scope.find('[data-exam-form-server-error]')[0],
			main = scope.find('main')[0],
			loading = scope.find('[data-exam-form-loading]')[0];

		if (!validateFields(scope, fields)) {
			form.scrollIntoView({behavior: 'smooth'});
			return false;
		}

		loading.classList.add('exam__loading-wrapper--open');

		let data = new FormData(),
			request = new XMLHttpRequest();

		fields.each(function(index, field) {
			let type = field.getAttribute('data-form-field-type');

			if (type === 'file') {
				data.append(
					field.files[0].name,
					JSON.stringify(
						{
							ID: field.getAttribute('data-form-field'),
							Type: type,
							FileName: field.files[0].name
						}
					)
				);
				data.append(
					field.getAttribute('data-form-field'),
					field.files[0],
					field.files[0].name
				);
			} else {
				data.append(
					index,
					JSON.stringify(
						{
							Value: field.value,
							ID: field.getAttribute('data-form-field'),
							Type: type
						}
					)
				);
			}
		});

		request.onreadystatechange = function() {
			console.log(request);

			if (request.readyState === XMLHttpRequest.DONE) {
				if (request.status === 200) {
					loading.classList.add('exam__loading-wrapper--open');
					form.classList.add('exam__form--hide');
					content.classList.add('exam__content--hide');
					postSubmission.classList.add('exam__post-subimssion-content--show');
					postSubmission.setAttribute('aria-hidden', 'false');
					main.scrollIntoView({behavior: 'smooth'});
				} else {
					loading.classList.remove('exam__loading-wrapper--open');
					serverError.classList.add('exam__server-error--show');
					serverError.setAttribute('aria-hidden', 'false');
				}
			}
		};

		request.open('POST', '/Exam/SubmitExam');
		request.setRequestHeader('SubmissionID', submissionID.value);
		request.send(data);
	}

	function validateFields(scope, fields) {
		var errorCount = 0;

		fields.each((index, item) => {
			let parentElement = item.closest('[data-exam-question]');

			if (!item.value.length) {
				parentElement.classList.add('exam__question--error');
				parentElement.querySelector('[data-exam-field-question-error]').classList.add('exam__question-error--open');
				errorCount++;
			} else {
				parentElement.classList.remove('exam__question--error');
				parentElement.querySelector('[data-exam-field-question-error]').classList.remove('exam__question-error--open');
			}
		});

		if (errorCount !== 0) {
			return false;
		}

		return true;
	}

	init();
});

DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	const submitButton = '[data-sign-up-form-submit]';

	/**
	 * Initialize Button actions
	 */
	function init() {
		setup($(document));
	}

	/**
	 * Apply setup to our newly loaded area (document, or scope)
	 *
	 * @param scope | DOMObject - the area of the page we are applying this functionality to
	 */
	function setup(scope) {
		attachEvents(scope);
	}

	/**
	 * Attach events
	 * @param scope | DOMObject
	 */
	function attachEvents(scope) {
		scope.find(submitButton).on('click', function(e) {
			e.stopPropagation();
			e.preventDefault();
			submitForm(scope);
			checkEmail(scope);
		});

		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	function submitForm(scope) {
		if (!checkEmail(scope)) {
			return false;
		}

		const loadingIcon = scope.find('[data-sign-up-form-loading]');

		loadingIcon[0].classList.add('sign-up__loading-wrapper--open');
		sendRequest(scope);
	}

	function checkEmail(scope) {
		let emailField = scope.find('[data-sign-up-form-email]'),
			emailError = scope.find('[data-sign-up-form-email-error]');

		if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailField[0].value)) {
			emailField[0].classList.remove('sign-up__email-field--error');
			emailField[0].removeAttribute('aria-invalid');
			emailError[0].classList.remove('sign-up__email-error--error');
			return true;
		}

		emailField[0].classList.add('sign-up__email-field--error');
		emailField[0].setAttribute('aria-invalid', 'true');
		emailError[0].classList.add('sign-up__email-error--error');
		return false;
	}

	function sendRequest(scope) {
		if (scope === undefined) {
			return false;
		}

		const email = scope.find('[data-sign-up-form-email]'),
			error = scope.find('[data-sign-up-form-email-status]')[0],
			success = scope.find('[data-sign-up-form-success')[0],
			leftContent = scope.find('[data-sign-up-form-left-content')[0],
			rightContent = scope.find('[data-sign-up-form-right-content]')[0],
			loadingIcon = scope.find('[data-sign-up-form-loading]')[0];

		fetch('/NewsletterSignup/signup', {
			headers: {
				'Content-Type': 'application/json; charset=utf-8',
				email: email[0].value
			},
			method: 'POST'
		})
			.then(response => response.json())
			.then(data => {
				switch (data) {
					case 409:
					case 200:
						success.classList.add('sign-up__success-content--show');
						leftContent.classList.add('sign-up__left-content--hide');
						rightContent.classList.add('sign-up__right-content--hide');
						break;
					default:
						loadingIcon.classList.remove('sign-up__loading-wrapper--open');
						error.innerHTML = 'Sorry, there has been an error. Try again later';
				}
			});
	}

	init();
});

/**
* Slick slider init
*
*/
DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	if ($('.testimonial__wrapper').length > 1) {
		$('.testimonial__carousel-item').slick({
			infinite: true,
			slidesToShow: 1,
			adaptiveHeight: true
		});
	}
});

/**
 * Toggles and switches extra js (for accessibility).
 * Uses ../lib/toggles-switches.js from https://github.com/dsurgeons/Toggles-Switches
 */

DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	var focusable = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
		focusableNative = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed';

	/**
	 * Initialize Button actions
	 */
	function init() {
		setup($(document));
	}

	/**
	 * Apply setup to our newly loaded area (document, or scope)
	 *
	 * @param scope | DOMObject - the area of the page we are applying this functionality to
	 */
	function setup(scope) {
		// if aria hidden, we shouldn't be able to focus
		scope.find('[aria-hidden="true"]').find(focusable).attr('tabindex', '-1');

		attachEvents(scope);
	}

	/**
	 * If an element has the attribute data-toggle-aria we want to toggle the
	 * aria-hidden attribute of the data-toggle-aria value and the tabindex of
	 * all focusable children.
	 * @param scope | DOMObject
	 */
	function attachAriaHide(scope) {
		var targets = scope.find('[data-toggle-aria]');

		// Set aria hidden and tabindex -1
		targets.on('click', function() {
			var target = $(this).data('toggle-aria'),
				value = $(target).attr('aria-hidden') === 'false' ? 'true' : 'false',
				tabindex = value === 'false' ? '0' : '-1';

			$(target).attr('aria-hidden', value);
			$(target).find(focusable).attr('tabindex', tabindex);
		});
	}

	/**
	 * Attach events
	 * @param scope | DOMObject
	 */
	function attachEvents(scope) {
		attachAriaHide(scope);

		scope.find('[data-contain]').on('click', function(e) {
			e.stopPropagation();
		});

		// make sure we get the order of our events right
		setTimeout(function() {
			keyboardFocus(scope);
		}, 1000);

		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	/**
	 * Allow a focus state that only appears for people using keyboards to navigate
	 * @param scope | DOMObject
	 */
	function keyboardFocus(scope) {
		scope.find(focusable).on('keyup', function(e) {
			$(e.target).addClass('hasfocus');

			if ($(e.target).is(focusableNative)) {
				return;
			}

			// trigger click if this element doesn't usually support click
			if (e.keyCode === 13) {
				e.preventDefault();
				e.stopPropagation();
				$(e.target).trigger('click');
			}
		}).on('blur focusout', function(e) {
			$(e.target).removeClass('hasfocus');
		});
	}

	init();
});
